export const BASE_URL_SERVER = 'http://127.0.0.1:8080'
